import { serverDateToFormat } from 'helpers/formatters/date';
import { v4 as uuidV4 } from 'uuid';

const NO_VALUE = '-';

type Properties = {
  isLagged: boolean;
  defaultLagDate?: string;
  customLagDate?: string;
};

type LagDateInformation = {
  badge: JSX.Element | null;
  date: string;
};

const BadgeTemplate = (className: string, text: string): JSX.Element => {
  return (
    <span
      key={uuidV4()}
      className={'badge ' + className}
      style={{ padding: 5, marginLeft: 5 }}
    >
      {text}
    </span>
  );
};

export const Custom = () => {
  return BadgeTemplate('badge-info', 'CUSTOM');
};

export const Empty = () => {
  return BadgeTemplate('badge-danger', 'EMPTY');
};

/**
 * Return a Benchmark's Lag Date and Lag Badge individually.
 * @param properties Properties
 * @returns {LagDateInformation}
 */
export const LagDateInformation = (
  properties: Properties
): LagDateInformation => {
  const { isLagged, defaultLagDate, customLagDate } = properties;

  let badge = null;
  let date = NO_VALUE;

  if (isLagged) {
    // isLagged

    if (customLagDate) {
      //has customLagDate
      badge = Custom();
      date = customLagDate;
    } else {
      //no customLagDate
      if (defaultLagDate !== undefined) {
        //has defaultLagDate
        date = defaultLagDate;
      } else {
        badge = Empty();
        date = NO_VALUE;
      }
    }
  }

  if (date !== NO_VALUE) {
    date = serverDateToFormat(date);
  }

  return {
    badge,
    date,
  };
};

/**
 * Return Benchmark's Lag Date and Lag Badge as a single element.
 * @param properties
 */
export const LagDateBadge = (properties: Properties): JSX.Element => {
  const { badge, date } = LagDateInformation(properties);
  return (
    <>
      {date}
      {badge}
    </>
  );
};
